// Classe di utilità: Utils
// Raccolta di costanti, eventi custom e funzioni di supporto per tutto il tema.
// Attributi richiesti: nessuno specifico
// Dipendenze: nessuna obbligatoria, ma usato ovunque nel tema
// Limiti: nessuno
// Utilizzato come helper globale per eventi, costanti e funzioni comuni
class Utils {

  static E_PASSWORDEYE_SHOWN = "password-eye:shown";
  static E_PASSWORDEYE_HIDDEN = "password-eye:hidden";

  static E_FORM_SUBMIT = "form:submit";
  static E_FORM_SUCCESS = "form:success";
  static E_FORM_ERROR = "form:error";
  static E_FORM_SENT = "form:sent";
  static E_FORM_VALIDATE = "form:validate";
  static E_INPUT_VALIDATE = "input:validate";

  static E_SLIDER_CHANGE = "slider:change";

  static E_CART_ADDING = "cart:adding";
  static E_CART_ADDED = "cart:added";
  static E_CART_ERROR = "cart:error";
  static E_CART_REMOVED = "cart:removed";
  static E_CART_UPDATED = "cart:updated";
  
  static E_VARIANT_CHANGE = "variant:change";
  static E_VARIANT_CHANGING = "variant:changing";

  static E_FILTER_CHANGE = "filter:change";

  static E_MEGAMENU_SHOW = "megamenu:show";
  static E_MEGAMENU_HIDE = "megamenu:hide";

  static E_NEXT_STEP = "step:next";
  static E_CUSTOM_PROP_SELECTED = "custom-prop:selected";

  static E_COOKIES_CHANGED = "cookies:changed";

  static E_QUANTITY_CHANGE = "quantity:change";

  static E_RETURN_ORDER = "return:order";
  static E_RETURN_IBAN = "return:iban";

  static E_LIST_VIEWED = "list:viewed";
  static E_PRODUCT_CLICKED = "product:click";
  static E_SUCCESS = "form:success";
  static E_SIGNUP = "customer:signup";
  static E_LOGIN = "customer:login";
  static E_MENU_CLICK = "menu:click";
  static E_SOCIAL_CLICK = "social:click";
  static E_BANNER_CLICK = "banner:click";
  static E_BANNER_VIEW = "banner:view";
  static E_ANNOUNCEMENT_CLICK = "announcement:click";
  static E_CAROUSEL_CLICK = "carousel:click";
  static E_FOOTER_CLICK = "footer:click";
  static E_PILL_CLICK = "pill:click";
  static E_CART_CODE = "cart:code";
  static E_CART_CLICK = "cart:click";
  static E_RETURN_CREATED = "return:created";
  static E_CONTACT = "contact:submit";
  static E_BACKSTOCK = "product:backstock";

  static E_ERROR = "error:custom";
  
  static COOKIES_NEEDED = 1;
  static COOKIES_FUNCTIONAL = 2;
  static COOKIES_EXPERIENCE = 3;
  static COOKIES_MISURE = 4;
  static COOKIES_MARKETING = 5;
  
  static E_STORE_PROVINCE = "store:province";
  static E_STORE_STOCK = "store:stock";
  static E_STORES = "store:stores";
  static E_STORE_FOUND = "store:found";
  static E_STORE_MERGED = "store:merged";
  
  static API_URL = window.azureUrl;
  static SELLIGENT_API_URL = window.azureUrl;
  
  static dateFromTime = (timestr) => {
    var date = new Date();
    const time = timestr.split(" ").at(-1).split("T").at(-1);
    date.setHours(time.split(":")[0] || 0);
    date.setMinutes(time.split(":")[1] || 0);
    date.setSeconds(time.split(":")[2] || 0);
    return date;
  }

  static getDateOfWeek = (wstr) => {
    const w = parseInt(wstr.split("W").at(-1));
    const y = parseInt(wstr.split("W").at(0));
    var d = (1 + (w - 1) * 7);
    return new Date(y, 0, d);
  }

  static errorHanlder = (error, title, description, button) => {
    Swal.fire({
      title: title || window.formErrors.generic,
      text: description,
      icon: 'error',
      confirmButtonText: button || window.formErrors.close,
      iconColor: 'var(--bs-danger)',
      color: 'var(--bs-body-color)',
      background: 'var(--bs-body-bg)',
      customClass: {
        title: 'fs-5',
        confirmButton: 'btn btn-primary',
        container: 'fs-body',
        htmlContainer: 'fs-body'
      }
    })
  }

  static errorHandler = ({message, description, target, type, value, popup, error, button}) => {
    console.error(error ? error : message);
    Shopify.analytics.publish(Utils.E_ERROR, {
      message: message,
      target: target,
      type: type,
      value: value
    });
    if(popup){
      Utils.errorHanlder(error, message, description, button);
    }
  }

  static money = (amount) => {
    const a = parseFloat(amount/100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return window.currencyFormat.replace('{{amount}}', a).replace('{{amount_with_comma_separator}}', a);
  }

  static getProduct = (handle, options) => {
    const url = window.Shopify.routes.root + 'products/' + handle + '.js';
    axios.get(url).then((response) => {
      if(typeof options.success === 'function') {
        options.success(response.data);
      }
    }).catch((error) => {
      if(typeof options.error === 'function') {
        options.error(error);
      }
      Utils.errorHandler({
        message: error.response.data.message || error.message,
        target: 'get-product',
        error: error,
        type: 'axios'
      });
    }).finally(() => {
      if(typeof options.finally === 'function') {
        options.finally();
      }
    });
  }

  static addTocart = (params) => {
    const data = params.data || new FormData(params.form);
    const url = window.Shopify.routes.root + 'cart/add.js';
    window.dispatchEvent(new CustomEvent(Utils.E_CART_ADDING, { detail: data.get('id') }));
    if(typeof params.before === 'function') {
      params.before(data.form);
    }
    axios.post(url, data)
      .then((response) => {
        try {
          const added = JSON.parse(response.request.responseText);
          if(data.get('gender')){
            added.gender = data.get('gender');
          }
          window.dispatchEvent(new CustomEvent(Utils.E_CART_ADDED, { detail: added }));
          if(typeof params.success === 'function') {
            params.success(added);
          }
        } catch (e){
          window.dispatchEvent(new CustomEvent(Utils.E_CART_ERROR, { detail: e }));
          if(typeof params.error === 'function') {
            params.error(e);
          }
          Utils.errorHandler({
            message: "parse error",
            target: 'add-to-cart',
            error: e,
            type: 'read-error'
          });
        }
      })
      .catch((error) => {
        window.dispatchEvent(new CustomEvent(Utils.E_CART_ERROR, { detail: error }));
        Utils.errorHandler({
          message: error.response.data.message || error.message,
          target: 'add-to-cart',
          error: error,
          type: 'axios',
          popup: true
        });
        if(typeof params.error === 'function') {
          params.error(error);
        }
      })
      .finally(() => {
        if(typeof params.finally === 'function') {
          params.finally();
        }
      });
  }

  static getDocument = (html) => {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    return doc;
  }

  static cookieConsent = (data) => {
    window.cookieTypes = data.purposes;
    window.dispatchEvent(new CustomEvent(Utils.E_COOKIES_CHANGED, { detail: data }));
  }

  static hasCookie = (type) => {
    return window.cookieTypes[type];
  }

  static handleize = (str) => {
    return str.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '');
  }
}